/**
 * Modal window directive for Edit Live
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 06.03.2015-19:23
 */

lmApp.directive('lmEditLive2', [function () {
  return {
    restrict: 'E',
    replace: true,
    controller: 'LmEditLiveController2',
    templateUrl: 'lm-assets-edit/live/edit-live.tpl.html'
  };
}]);

lmApp
  .controller('LmEditLiveController2', ['$scope', '$rootScope', '$templateCache', '$compile', '$q', '$timeout', '$interval', 'MetadataService', 'AssetService', 'ToastService', 'GroupService', 'OfferService', 'PlanService', 'PackageService', 'YoutubeService',
    function ($scope, $rootScope, $templateCache, $compile, $q, $timeout, $interval, MetadataService, AssetService, ToastService, GroupService, OfferService, PlanService, PackageService, YoutubeService) {

      $scope._STREAM_TYPES_ATTRS = MetadataService._STREAM_TYPES_ATTRS;
      $scope.getStreamTypeAttrs = MetadataService.getStreamTypeAttrs;

      /**
       * Process media in asset.
       * @param asset
       */
      $scope.mediaManager = function (asset) {
        if ($scope.loading) return;

        MetadataService.MediaManager(asset, $scope);
      };

      $scope.deleteStream = function (stream) {
        stream.toDelete = true;
      };

      /**
       * TODO: SCOPES!!!!!
       *
       * Allow to Edit next asset in collection (if not Last)
       */
      $scope.$parent.nextAsset = function () {
        if ($scope.$parent.loading) return;

        if ($scope.$parent.currentFocused < $scope.localCollection.length - 1) {
          $scope.$parent.currentFocused++;
          $scope.localCollection[$scope.$parent.currentFocused]._PrivateData = {};
          $scope.asset = $scope.localCollection[$scope.$parent.currentFocused];
          $scope.assetData = $scope.prepareAssetForEdit($scope.asset);
        }
      };

      /**
       * TODO: SCOPES!!!!
       *
       * Allow ti Edit previous asset in collection (if not First)
       */
      $scope.$parent.previousAsset = function () {
        if ($scope.$parent.loading) return;

        if ($scope.$parent.currentFocused > 0) {
          $scope.$parent.currentFocused--;
          $scope.localCollection[$scope.$parent.currentFocused]._PrivateData = {};
          $scope.asset = $scope.localCollection[$scope.$parent.currentFocused];
          $scope.assetData = $scope.prepareAssetForEdit($scope.asset);
        }
      };

      $scope.removeFromRotation = function (assetData) {
        assetData._PrivateData.rentalNew.rotation_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.rotation_finish = moment.utc().subtract(1, 'day');
      };

      $scope.setOneMonthRotation = function (assetData) {
        assetData._PrivateData.rentalNew.license_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.license_finish = moment.utc().add(1, 'month');
        assetData._PrivateData.rentalNew.rotation_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.rotation_finish = moment.utc().add(1, 'month');
      };

      $scope.setOneYearRotation = function (assetData) {
        assetData._PrivateData.rentalNew.license_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.license_finish = moment.utc().add(1, 'year');
        assetData._PrivateData.rentalNew.rotation_start = moment.utc().subtract(1, 'day');
        assetData._PrivateData.rentalNew.rotation_finish = moment.utc().add(1, 'year');
      };

      /**
       * Prepare asset for Edit. Add '_PrivateData' filed with parsed metadata
       * @param assetData
       * @returns {*}
       */
      $scope.prepareAssetForEdit = function (assetData) {

        assetData._PrivateData.qualityFormats = [
          {
            title: 'HD',
            isSelected: false
          },
          {
            title: 'SD',
            isSelected: false
          }
        ];

        assetData._PrivateData.adultContent = assetData.has_adult_content;

        assetData._PrivateData.rentalOld = MetadataService.Rental.GetValues(assetData);
        assetData._PrivateData.rentalNew = angular.copy(assetData._PrivateData.rentalOld);

        assetData._PrivateData.tagsOld = assetData.tags ? assetData.tags : [];
        assetData._PrivateData.tagsNew = angular.copy(assetData._PrivateData.tagsOld);

        assetData._PrivateData.genresOld = assetData.genres.map(function (genre) {
          return {
            title: genre.title,
            id: genre.id
          }
        });

        assetData._PrivateData.genresNew = angular.copy(assetData._PrivateData.genresOld);
        AssetService.GetGenresCollection()
          .then(function (answer) {
            $scope.genreSearch = answer.map(function (genre) {
              return {
                title: genre.title,
                id: genre.id
              }
            });
          })
          .catch(function (reason) {
            $scope.genreSearch = [];
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 6);
          });

        $scope.epg = {};
        AssetService.GetEpgIDCollection()
          .then(function (answer) {
            answer.forEach(function (epg) {

              if (!epg.title) epg.title = epg.extid;
            });

            $scope.epg.epgIDSearch = answer.map(function (epg) {
              return {
                title: epg.title + '<br> <span class="tc-grey-600"> [' + epg.extid + '] </span>',
                smallTitle: epg.title,
                id: epg.id
              }
            });

            assetData._PrivateData.epgChannelIdOld = _.find(answer, {id: assetData.epg_channel_id});
            assetData._PrivateData.epgChannelIdNew = angular.copy(assetData._PrivateData.epgChannelIdOld);

          }, function (reason) {
            $scope.epg.epgIDSearch = [];
            $rootScope.debugInfo(reason);
          });

        assetData._PrivateData.categoriesOld = assetData.categories.map(function (item) {
          return {
            title: item.title,
            id: item.id
          };
        });
        assetData._PrivateData.categoriesNew = angular.copy(assetData._PrivateData.categoriesOld);
        AssetService.GetCategoryCollection()
          .then(function (answer) {
            $scope.categorySearch = answer.map(function (category) {
              return {
                title: category.title,
                id: category.id
              }
            });
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason);
          });

        AssetService.GetProvidersCollection()
          .then(function (answer) {
            $scope.providerSearch = answer.map(function (provider) {
              return {
                title: provider.title,
                id: provider.id
              }
            });
            if (assetData.provider) {
              assetData._PrivateData.providersOld = _.find(answer, {title: assetData.provider.title});
              assetData._PrivateData.providersNew = angular.copy(assetData._PrivateData.providersOld);
            }
          })
          .catch(function (reason) {
            $scope.providerSearch = [];
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 6);
          });

        GroupService.GetGroups()
          .then(function (collection) {
            $scope.groupSearch = collection.map(function (group) {
              return {
                title: group.name,
                id: group.id
              }
            });

            assetData._PrivateData.groupsOld = collection
              .filter(function (group) {
                return _.includes(assetData.group_id, group.id);
              })
              .map(function (group) {
                return {
                  title: group.name,
                  id: group.id
                }
              });
            assetData._PrivateData.groupsNew = angular.copy(assetData._PrivateData.groupsOld);
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 6);
          });

          OfferService.GetOffers()
              .then(function (collection) {
                  $scope.offerSearch = collection.map(function (offer) {
                      return {
                          title: offer.name,
                          id: offer.id
                      }
                  });

                  assetData._PrivateData.offersOld = collection
                      .filter(function (offer) {
                          return _.includes(assetData.offer_id, offer.id);
                      })
                      .map(function (offer) {
                          return {
                              title: offer.name,
                              id: offer.id
                          }
                      });
                  assetData._PrivateData.offersNew = angular.copy(assetData._PrivateData.offersOld);
              })
              .catch(function (reason) {
                  $rootScope.debugInfo(reason, 'silent');
                  ToastService.Small({
                      title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                      color: 'amber',
                      icon: 'server-off',
                      blocked: true
                  }, 1000 * 6);
              });

          PlanService.GetPlans()
              .then(function (collection) {
                  $scope.planSearch = collection.map(function (offer) {
                      return {
                          title: offer.name,
                          id: offer.id
                      }
                  });

                  assetData._PrivateData.plansOld = collection
                      .filter(function (offer) {
                          return _.includes(offer.assets, assetData.id);
                      })
                      .map(function (offer) {

                          return {
                              title: offer.name,
                              id: offer.id
                          }
                      });

                  assetData._PrivateData.plansNew = angular.copy(assetData._PrivateData.plansOld);
              })
              .catch(function (reason) {
                  $rootScope.debugInfo(reason, 'silent');

                  ToastService.Small({
                      title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
                      color: 'amber',
                      icon: 'server-off',
                      blocked: true
                  }, 1000 * 6);
              });

        PackageService.GetPackages()
          .then(function (collection) {
            $scope.packageSearch = collection.map(function (pkg) {
              return {
                title: pkg.title,
                id: pkg.id
              }
            });

            assetData._PrivateData.packagesOld = collection
              .filter(function (pkg) {
                return _.includes(assetData.package_id, pkg.id);
              })
              .map(function (pkg) {
                return {
                  title: pkg.title,
                  id: pkg.id
                }
              });
            assetData._PrivateData.packagesNew = angular.copy(assetData._PrivateData.packagesOld);
          })
          .catch(function (reason) {
            $rootScope.debugInfo(reason, 'silent');
            ToastService.Small({
              title: 'Sorry, some services are unavailable right now. If you\'re still having problems, try reloading the page',
              color: 'amber',
              icon: 'server-off',
              blocked: true
            }, 1000 * 6);
          });

        var pictureResources = assetData.resources && assetData.resources.filter(function (resourse) {
            return resourse.category === 'poster_blueprint';
          });

        if (pictureResources && pictureResources.length) {
          AssetService.GetPoster(assetData)
            .then(function (answer) {
              assetData._PrivateData.posterUrl = answer;
            });

          assetData._PrivateData.posterResourceId = pictureResources[0].id;
          assetData._PrivateData.posterOld = pictureResources[0].source;
          assetData._PrivateData.posterNew = assetData._PrivateData.posterOld;
        } else {
          assetData._PrivateData.posterOld = '';
          assetData._PrivateData.posterNew = '';
        }

        var streamsResources = {};

        assetData.resources.forEach(function (resource) {

          if (resource.type === 'stream' && !resource.category) {
            streamsResources[resource.stream_type] = {};
            streamsResources[resource.stream_type].streamUrl = '';
            streamsResources[resource.stream_type].streamResourceId = null;
            streamsResources[resource.stream_type].title = $scope.getStreamTypeAttrs(resource.stream_type).title;
            streamsResources[resource.stream_type].placeholder = $scope.getStreamTypeAttrs(resource.stream_type).placeholder;
            streamsResources[resource.stream_type].streamOld = '';
            streamsResources[resource.stream_type].streamNew = '';
            streamsResources[resource.stream_type].toDelete = false;

            AssetService.GetStream(assetData, resource.stream_type)
              .then(function (answer) {
                streamsResources[resource.stream_type].streamUrl = answer;
              });

            if (resource.stream_type.indexOf('youtube') !== -1) {
              resource.stream_type = 'youtube';
            }

            if (resource.stream_type.indexOf('youtube') !== -1) {
              streamsResources[resource.stream_type].streamOld = resource.source
                .replace('youtube+user://', 'https://www.youtube.com/user/')
                .replace('youtube+channel://', 'https://www.youtube.com/channel/');
              streamsResources[resource.stream_type].source = streamsResources[resource.stream_type].streamOld;
              streamsResources[resource.stream_type].streamNew = streamsResources[resource.stream_type].streamOld;
            } else {
              streamsResources[resource.stream_type].streamOld = resource.source;
              streamsResources[resource.stream_type].streamNew = streamsResources[resource.stream_type].streamOld;
              streamsResources[resource.stream_type].source = resource.original_source || resource.source;
              streamsResources[resource.stream_type].doneWithError = resource.noisypeak_job_is_complete && resource.noisypeak_job_error ? resource.noisypeak_job_error : '';
              streamsResources[resource.stream_type].transcoding = !resource.noisypeak_job_is_complete && !resource.noisypeak_job_error ? resource.noisypeak_job_progress : '';

              streamsResources[resource.stream_type].strategy = 'ORIGIN';

              if (resource.delivery_method === 'cdn') {
                streamsResources[resource.stream_type].strategy = 'CDN';
              } else if (resource.url === resource.source) {
                streamsResources[resource.stream_type].strategy = 'DIRECT';
              }
            }

            streamsResources[resource.stream_type].streamResourceId = resource.id;
          }
        });

        assetData._PrivateData.streamsResources = streamsResources;

        var catchupResources = assetData.resources && assetData.resources.filter(function (resourse) {
            return resourse.category === 'catchup';
          });

        if (catchupResources && catchupResources.length) {
          assetData._PrivateData.catchupOld = {
            isEnabled: assetData.is_catchup_available,
            depth: MetadataService.Catchup.GetValue(catchupResources[0]),
            source: catchupResources[0].source
          };

          assetData._PrivateData.catchupNew = angular.copy(assetData._PrivateData.catchupOld);
        } else {
          assetData._PrivateData.catchupOld = {
            isEnabled: false,
            depth: 0,
            source: ''
          };

          assetData._PrivateData.catchupNew = angular.copy(assetData._PrivateData.catchupOld);
        }

        assetData._PrivateData.qualityFormat = assetData.traits[0];

        assetData._PrivateData.platformsOld = MetadataService.Platforms.GetAvailablePlatforms(assetData, $rootScope.platforms);
        assetData._PrivateData.platformsNew = angular.copy(assetData._PrivateData.platformsOld);

        return assetData;
      };

      /**
       * Get current Asset data on window Open
       */
      $scope.assetData = $scope.prepareAssetForEdit($scope.asset);
      $scope.validateFields = MetadataService.ValidateMetadata.Live;

      /**
       * @define [CREATE]
       * Defines Create function for asset
       * @param newAsset
       */
      $scope.$parent.createFn = function (newAsset) {
        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        if (!_.isEmpty($scope.validateFields(newAsset))) {
          $scope.$parent.loading = false;
          $rootScope.hideLinearProgress('#modalLoader');
          ToastService.Big({
            color: 'amber',
            title: 'Empty fields',
            text: 'Not all required fields are filled. Check all marked fields',
            icon: 'alert'
          }, 60 * 1000);
          return;
        }

        var ext_id = "personal:" + translit(newAsset.title) + ':' + CryptoJS.MD5(newAsset.title).toString(CryptoJS.enc.Hex) + ':' + guid();

        if (newAsset._PrivateData.epgChannelIdNew) newAsset.epg_channel_id = newAsset._PrivateData.epgChannelIdNew ? newAsset._PrivateData.epgChannelIdNew.id : undefined;
        if (newAsset._PrivateData.providersNew) newAsset.provider = newAsset._PrivateData.providersNew.id;

        AssetService.CreateNewLive(ext_id, newAsset)
          .then(function (response) {

            var allQ = {};

            newAsset.id = response.asset.id;

            newAsset.definition = newAsset._PrivateData.qualityFormat || 'SD';
            allQ.commonMetadata = AssetService.UpdateCommonAssetMetadata.bind(this, {asset_id: newAsset.id, definition: newAsset.definition, provider_id: newAsset.provider});

            allQ.adult = AssetService.SetAdult.bind(this, newAsset.id, newAsset._PrivateData.adultContent);

            allQ.streams = AssetService.ProcessVodStreams.bind(this, newAsset._PrivateData.streamsResources, newAsset.id);

            if (newAsset._PrivateData.posterNew) {
              allQ.picture = AssetService.AddVodPoster.bind(this, newAsset._PrivateData.posterNew, newAsset.id);
            } else {
              allQ.picture = AssetService.AddVodPoster.bind(this, 'https://storage-sc-ott3.s3.amazonaws.com/no-channel-logo.png', newAsset.id);
            }

            var TvCategory = $scope.categorySearch.filter(function (category) {
              return category.title === 'TV';
            });

            if (TvCategory.length) newAsset._PrivateData.categoriesNew = newAsset._PrivateData.categoriesNew.concat(TvCategory);

            allQ.tags = AssetService.tagsSet.bind(this, newAsset._PrivateData.tagsNew, newAsset.id);

            allQ.genres = MetadataService.Genres.Update.bind(this, [], newAsset._PrivateData.genresNew, newAsset.id);

            allQ.categories = MetadataService.Categories.Update.bind(this, [], newAsset._PrivateData.categoriesNew, newAsset.id);

            allQ.platforms = MetadataService.Platforms.Update.bind(this, [], newAsset._PrivateData.platformsNew, newAsset.id);

            allQ.rental = AssetService.UpdateRentalRotation.bind(this, newAsset._PrivateData.rentalNew, newAsset.id);

            if (!_.isEqual(newAsset._PrivateData.catchupNew, newAsset._PrivateData.catchupOld)) {

              if (!newAsset._PrivateData.catchupNew.isEnabled) {
                allQ.catchup = AssetService.CatchupDisable.bind(this, newAsset);
              } else {
                allQ.catchup = AssetService.CatchupEnable.bind(this, newAsset, newAsset._PrivateData.catchupNew.source, newAsset._PrivateData.catchupNew.depth);
              }
            }

            var groupToRemove = _.difference(_.map(newAsset._PrivateData.groupsOld, 'id'), _.map(newAsset._PrivateData.groupsNew, 'id'));
            var groupToAdd = _.difference(_.map(newAsset._PrivateData.groupsNew, 'id'), _.map(newAsset._PrivateData.groupsOld, 'id'));
            if (groupToAdd.length) allQ.groupsAdd = GroupService.AddAsset.bind(this, groupToAdd, [response.asset.id]);
            if (groupToRemove.length) allQ.groupsRemove = GroupService.RemoveAsset.bind(this, groupToRemove, [response.asset.id]);

            var concatOffersOld = _.concat([],newAsset._PrivateData.offersOld, newAsset._PrivateData.plansOld);
            var concatOffersNew = _.concat([],newAsset._PrivateData.offersNew, newAsset._PrivateData.plansNew);
            var offerToRemove = _.difference(_.map(concatOffersOld, 'id'), _.map(concatOffersNew, 'id'));
            var offerToAdd = _.difference(_.map(concatOffersNew, 'id'), _.map(concatOffersOld, 'id'));
            if (offerToAdd.length) allQ.offersAdd = OfferService.AddAsset.bind(this, offerToAdd, [response.asset.id]);
            if (offerToRemove.length) allQ.offersRemove = OfferService.RemoveAsset.bind(this, offerToRemove, [response.asset.id]);

            var packageToRemove = _.difference(_.map(newAsset._PrivateData.packagesOld, 'id'), _.map(newAsset._PrivateData.packagesNew, 'id'));
            var packageToAdd = _.difference(_.map(newAsset._PrivateData.packagesNew, 'id'), _.map(newAsset._PrivateData.packagesOld, 'id'));
            if (packageToAdd.length) allQ.packagesAdd = PackageService.AddAsset.bind(this, packageToAdd, [response.asset.id]);
            if (packageToRemove.length) allQ.packagesRemove = PackageService.RemoveAsset.bind(this, packageToRemove, [response.asset.id]);

            $q.seqAll(allQ)
              .then(function () {
                $rootScope.hideLinearProgress('#modalLoader');
                $scope.$parent.loading = false;

                ToastService.Small({
                  title: 'TV Channel: <b class="tc-white">' + newAsset.title + '</b> successfully created',
                  color: 'green',
                  icon: 'cloud-check'
                }, 1000 * 6);

                $scope.close();
                $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {id: 'all'});

                return true;
              })
              .catch(function (reason) {
                $rootScope.hideLinearProgress('#modalLoader');
                $scope.$parent.loading = false;

                ToastService.Small({
                  title: 'TV Channel: <b class="tc-white">' + newAsset.title + '</b> create failed',
                  color: 'red',
                  icon: 'cloud-outline-off'
                }, 1000 * 6);

                ToastService.Big({
                  title: 'Errors during creation',
                  color: 'red',
                  text: reason.key + ': ' + reason.error.message,
                  icon: 'cloud-outline-off'
                }, 1000 * 6 * 3);

                $rootScope.debugInfo(reason.error);

                return reason;
              });
          })
          .catch(function (reason) {
            $scope.$parent.loading = false;
            $rootScope.debugInfo(reason);
            $rootScope.hideLinearProgress('#modalLoader');

            if (reason.message === 'item with this ext_id already exist') {
              ToastService.Small({
                title: 'TV Channel with this title already exist',
                color: 'red',
                icon: 'cloud-outline-off'
              }, 1000 * 6);
            } else {
              ToastService.Small({
                title: 'TV Channel: <b class="tc-white">' + newAsset.title + '</b> create failed',
                color: 'red',
                icon: 'cloud-outline-off'
              }, 1000 * 6);
            }
            return false;
          });
      };

      /**
       * @define [UPDATE]
       * Defines Update function for asset
       * @param asset
       */
      $scope.$parent.updateFn = function (asset) {
        $rootScope.showLinearProgress('#modalLoader');
        $scope.$parent.loading = true;

        var allQ = {};

        if (!_.isEmpty($scope.validateFields(asset))) {
          $scope.$parent.loading = false;
          $rootScope.hideLinearProgress('#modalLoader');
          ToastService.Big({
            color: 'amber',
            title: 'Empty fields',
            text: 'Not all required fields are filled. Check all marked fields.',
            icon: 'alert'
          }, 60 * 1000);
          return;
        }

        if (asset._PrivateData.epgChannelIdNew) asset.epg_channel_id = asset._PrivateData.epgChannelIdNew ? asset._PrivateData.epgChannelIdNew.id : undefined;
        if (asset._PrivateData.catchupNew.isEnabled) asset.is_catchup_available = asset._PrivateData.catchupNew.isEnabled;

        if (asset._PrivateData.providersNew) {
          asset.provider = asset._PrivateData.providersNew.id;
        } else {
          asset.provider = 0;
        }

        allQ.adult = AssetService.SetAdult.bind(this, asset.id, asset._PrivateData.adultContent);

        asset.definition = asset._PrivateData.qualityFormat || 'SD';
        allQ.metadata = AssetService.UpdateLiveMetadata.bind(this, asset);
        allQ.metadataCommon = AssetService.UpdateCommonAssetMetadata.bind(this, {asset_id: asset.id, definition: asset.definition, provider_id: asset.provider});

        allQ.tags = AssetService.tagsSet.bind(this, asset._PrivateData.tagsNew, asset.id);

        allQ.genres = MetadataService.Genres.Update.bind(this, asset._PrivateData.genresOld, asset._PrivateData.genresNew, asset.id);

        allQ.categories = MetadataService.Categories.Update.bind(this, asset._PrivateData.categoriesOld, asset._PrivateData.categoriesNew, asset.id);

        allQ.rental = AssetService.UpdateRentalRotation.bind(this, asset._PrivateData.rentalNew, asset.id);

        allQ.streams = AssetService.ProcessVodStreams.bind(this, asset._PrivateData.streamsResources, asset.id);

        allQ.platforms = MetadataService.Platforms.Update.bind(this, asset._PrivateData.platformsOld, asset._PrivateData.platformsNew, asset.id);

        if (!asset._PrivateData.posterOld && asset._PrivateData.posterNew) {
          allQ.picture = AssetService.AddVodPoster.bind(this, asset._PrivateData.posterNew, asset.id);
        } else if (asset._PrivateData.posterNew !== asset._PrivateData.posterOld) {
          allQ.picture = AssetService.UpdateVodPoster.bind(this, asset.id, asset._PrivateData.posterNew, asset._PrivateData.posterResourceId);
        }

        if (!_.isEqual(asset._PrivateData.catchupNew, asset._PrivateData.catchupOld)) {
          if (!asset._PrivateData.catchupNew.isEnabled) {
            allQ.catchup = AssetService.CatchupDisable.bind(this, asset);
          } else {
            allQ.catchup = AssetService.CatchupEnable.bind(this, asset, asset._PrivateData.catchupNew.source, asset._PrivateData.catchupNew.depth);
          }
        }

        var groupToRemove = _.difference(_.map(asset._PrivateData.groupsOld, 'id'), _.map(asset._PrivateData.groupsNew, 'id'));
        var groupToAdd = _.difference(_.map(asset._PrivateData.groupsNew, 'id'), _.map(asset._PrivateData.groupsOld, 'id'));
        if (groupToAdd.length) allQ.groupsAdd = GroupService.AddAsset.bind(this, groupToAdd, [asset.id]);
        if (groupToRemove.length) allQ.groupsRemove = GroupService.RemoveAsset.bind(this, groupToRemove, [asset.id]);

        var concatOffersOld = _.concat([],asset._PrivateData.offersOld, asset._PrivateData.plansOld);
        var concatOffersNew = _.concat([],asset._PrivateData.offersNew, asset._PrivateData.plansNew);
        var offerToRemove = _.difference(_.map(concatOffersOld, 'id'), _.map(concatOffersNew, 'id'));
        var offerToAdd = _.difference(_.map(concatOffersNew, 'id'), _.map(concatOffersOld, 'id'));
        if (offerToAdd.length) allQ.offersAdd = OfferService.AddAsset.bind(this, offerToAdd, [asset.id]);
        if (offerToRemove.length) allQ.offersRemove = OfferService.RemoveAsset.bind(this, offerToRemove, [asset.id]);

        var packageToRemove = _.difference(_.map(asset._PrivateData.packagesOld, 'id'), _.map(asset._PrivateData.packagesNew, 'id'));
        var packageToAdd = _.difference(_.map(asset._PrivateData.packagesNew, 'id'), _.map(asset._PrivateData.packagesOld, 'id'));
        if (packageToAdd.length) allQ.packagesAdd = PackageService.AddAsset.bind(this, packageToAdd, [asset.id]);
        if (packageToRemove.length) allQ.packagesRemove = PackageService.RemoveAsset.bind(this, packageToRemove, [asset.id]);

        return $q.seqAll(allQ)
          .then(function () {
            $rootScope.hideLinearProgress('#modalLoader');
            $scope.$parent.loading = false;
            ToastService.Small({
              title: 'TV Channel: <b class="tc-white">' + asset.title + '</b> successfully updated',
              color: 'green',
              icon: 'cloud-check'
            }, 1000 * 6);

            $scope.close();
            $rootScope.$broadcast($rootScope.EVENTS.UPDATE_LIVE_COLLECTION, {
              id: asset.id
            });

            return true;
          }).catch(function (reason) {
            $rootScope.hideLinearProgress('#modalLoader');
            $scope.$parent.loading = false;

            ToastService.Small({
              title: 'TV Channel: <b class="tc-white">' + asset.title + '</b> update failed',
              color: 'orange',
              icon: 'cloud-outline-off'
            }, 1000 * 6);

            ToastService.Big({
              title: 'Errors during update',
              color: 'orange',
              text: reason.key + ': ' + reason.error.message,
              icon: 'cloud-outline-off'
            }, 1000 * 6 * 3);

            $rootScope.debugInfo(reason.error);

            return reason;
          });
      };

      /**
       * Define Function on Select EDG id
       * @param data
       * @constructor
       */
      $scope.EpgSelectedChange = function (data) {
        if (!data.selected.length) {
          $scope.assetData._PrivateData.catchupNew = {
            isEnabled: false,
            depth: 0,
            source: ''
          };
        } else {
          $scope.assetData.title = ($scope.assetData.title) ? $scope.assetData.title : data.selected[0].title;
          $scope.assetData.is_epg_available = true;
        }
      };

      var streamWatch = $scope.$watch('assetData._PrivateData.streamNew', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          $scope.assetData._PrivateData.catchupNew = {
            isEnabled: false,
            depth: 0,
            source: ''
          };
        }
      });

      var epgIdWatch = $scope.$watch('assetData._PrivateData.epgChannelIdNew', function (newValue, oldValue) {
        if (!_.isEqual(newValue, oldValue)) {
          if (!_.isEmpty(newValue)) {
            $timeout(function () {
              //TODO: fix html
              $scope.assetData.title = ($scope.assetData.title) ? $scope.assetData.title : newValue.smallTitle;
              $scope.assetData.is_epg_available = true;
            });
          } else {
            $scope.assetData.is_epg_available = false;
          }
        }
      });

      var epgWatch = $scope.$watch('assetData.is_epg_available', function (newValue, oldValue) {
        if (newValue !== oldValue) {
          if (!newValue) $timeout(function () {
            $scope.assetData._PrivateData.catchupNew = {
              isEnabled: false,
              depth: 0,
              source: ''
            };
            $scope.assetData._PrivateData.epgChannelIdNew = {}
          });
        }
      });

      /**
       * Open window with catchup options
       * @param asset
       */
      $scope.setCatchupOptions = function (asset) {
        if (!(asset._PrivateData.streamsResources['hls_live'].streamNew || asset._PrivateData.streamsResources['hls_live'].source)) return;

        MetadataService.Catchup.ChangeValue(asset, $scope);
      };

      $scope.checkLcn = function (asset) {
        if ($scope.IntLcn) $timeout.cancel($scope.IntLcn);

        $scope.IntLcn = $timeout(function () {

          AssetService.getChannelByLcn(asset.er_lcn)
            .then(function (collection) {
              asset._PrivateData.validateWarning = {};
              if (collection.length && !_.find(collection, {id: asset.id})) {
                asset._PrivateData.validateWarning.lcn = true;
                asset._PrivateData.validateWarning.lcnText = 'Already exist';
              }
            })
        }, 150);
      };

      $scope.$on('$destroy', function () {
        epgWatch();
        epgIdWatch();
        streamWatch();
      });

      /**
       * Fetch data from IMDB
       * @param stream
       */
      $scope.fetchFromYoutube = function (stream) {
        return YoutubeService.FetchFromYoutube($scope, stream || {}, 'channel');
      };

      $scope.manageLocalizations = function () {
        MetadataService.LocalizationManager($scope.asset, $scope);
      }
    }]);
